module.exports = "<adf-host-settings (cancel)=\"onCancel()\" (success)=\"onSuccess()\" (error)=\"onError($event)\"></adf-host-settings>\r\n"